import { render, staticRenderFns } from "./ForAcceptanceCompaniesTab.vue?vue&type=template&id=168ee03c&scoped=true&"
import script from "./ForAcceptanceCompaniesTab.vue?vue&type=script&lang=js&"
export * from "./ForAcceptanceCompaniesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168ee03c",
  null
  
)

export default component.exports